import { render, staticRenderFns } from "./applicationMassage.vue?vue&type=template&id=4a105a24&scoped=true&"
import script from "./applicationMassage.vue?vue&type=script&lang=ts&"
export * from "./applicationMassage.vue?vue&type=script&lang=ts&"
import style0 from "./applicationMassage.vue?vue&type=style&index=0&id=4a105a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a105a24",
  null
  
)

export default component.exports